module.exports = __webpack_public_path__ + "static/invoices-39ffaf0f8f8c7db8431c71fd69cf808c.png";